// extracted by mini-css-extract-plugin
export default {"PreaboutContainer":"Preabout_PreaboutContainer__ml-pV"};